import { IBranch } from "../shared/types/branch.types";
import { BaseServiceLegacy } from "./base.service.legacy";

export class BranchService extends BaseServiceLegacy<IBranch> {
  constructor() {
    super("/branches");
  }
}
